import React from "react";
import Page from "src/components/Page";
import View from "./view";

function Index() {
  return (
    <Page>
      <View />
    </Page>
  );
}

export default Index;
